// Render and validate billing address fields
import React from "react";
import { useFormContext } from "react-hook-form";
import Country from "./Country";

const BillingAddressFields = () => {
  const {
    register,
    formState: { errors, dirtyFields },
  } = useFormContext();
  return (
    <div className="component-billing-address-fields">
      <h3>Billing address</h3>
      <div className="field">
        <input
          id="billing_line1"
          type="text"
          placeholder=" "
          {...register("billing_line1", {
            required: true,
          })}
          className={
            (errors.billing_line1 && "error") ||
            (dirtyFields.billing_line1 && "valid")
          }
        />
        <label htmlFor="billing_line1">Address Line 1</label>
        <span className="field-error-msg">
          {errors?.billing_line1?.type === "required" &&
            "Please enter your street address"}
        </span>
      </div>

      <div className="field">
        <input
          id="billing_line2"
          type="text"
          placeholder=" "
          {...register("billing_line2")}
          className={
            (errors.billing_line2 && "error") ||
            (dirtyFields.billing_line2 && "valid")
          }
        />
        <label htmlFor="billing_line2">Address Line 2</label>
      </div>

      <div className="field">
        <input
          id="billing_city"
          type="text"
          placeholder=" "
          {...register("billing_city", {
            required: true,
          })}
          className={
            (errors.billing_city && "error") ||
            (dirtyFields.billing_city && "valid")
          }
        />
        <label htmlFor="billing_city">City</label>
        <span className="field-error-msg">
          {errors?.billing_city?.type === "required" &&
            "Please enter your city or town"}
        </span>
      </div>

      <div className="field">
        <input
          id="billing_state"
          type="text"
          placeholder=" "
          {...register("billing_state", {
            required: true,
          })}
          className={
            (errors.billing_state && "error") ||
            (dirtyFields.billing_state && "valid")
          }
        />
        <label htmlFor="billing_state">State</label>
        <span className="field-error-msg">
          {errors?.billing_state?.type === "required" &&
            "Please enter your state or province"}
        </span>
      </div>

      <div className="field">
        <input
          id="billing_zip"
          type="text"
          placeholder=" "
          {...register("billing_zip", {
            required: true,
          })}
          className={
            (errors.billing_zip && "error") ||
            (dirtyFields.billing_zip && "valid")
          }
        />
        <label htmlFor="billing_zip">Postal Code</label>
        <span className="field-error-msg">
          {errors?.billing_zip?.type === "required" &&
            "Please enter your postal code"}
        </span>
      </div>
      <div className="field">
        <Country name="billing_country" />
      </div>
    </div>
  );
};
export default BillingAddressFields;
